<template>
  <div class="page">
    <p class="p1">
      积分明细
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div>
      <ul>
        <li class="li_class" v-for="(item,index) in packageList" :key="index">
          <div class="li-div">
            <span>{{item.source}}</span>
            <span v-if="item.payType == 1" class="shutdown">{{"+"+ item.integral}}</span>
            <span v-if="item.payType == 2" class="shutdown1">{{item.integral}}</span>
          </div>
          <div class="li-div">
            <span>{{item.orderNum}}</span>
            <span>{{item.payTime}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { wx_userIntegralDetailList } from "@/api/api.js"; 
import { wx_cardIntegralDetailList } from "@/api/api.js"; 
export default {
  data() {
    return {
      packageList:[]
    };
  },
  computed: {},
  methods: {
    // 实名状态
    realnamestatus(status) {
      let obj = { 
        1: "充值",
        2: "赠送 ",
        3: "兑换",
      };
      return obj[status];
    },
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    initData(){
      if(this.$route.query.iccid){
        wx_cardIntegralDetailList({iccid:this.$route.query.iccid}).then(res => {
          if(res.data.code == 200){
            this.packageList = res.data.data;
            this.packageList.map(item=>{
              item.source = this.realnamestatus(item.source);
              item.payTime = item.payTime.substr(0,10)
            })
          }
        })
      }else{
        wx_userIntegralDetailList().then(res => {
          if(res.data.code == 200){
            this.packageList = res.data.data;
            this.packageList.map(item=>{
              item.source = this.realnamestatus(item.source);
              item.payTime = item.payTime.substr(0,10)
            })
          }
        })
      }
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "积分明细";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .li_class{
      padding: 5px 13px;
      width: 100%;
      height: 65px;
      font-size: 13px;
      border-bottom: 2px solid #ededed;
      .li-div{
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
      }
    }
  }
  .shutdown{
    color: red;
    font-size: 20px;
  }
  .shutdown1{
    color:#88DCA1;
    font-size: 20px;
  }
</style>

